<template>
    <div class="footer" id="footer">
        <div class="f1 footerTopspots container">
            <div class="footerTopspotD">
                <a href="https://cardkingdom.freshdesk.com/support/home" target="_blank" data-cktag="Customer Service">
                    <div class="topspotImage"><span class="glyphicon glyphicon-heart"></span></div>
                    <div class="topspotHeading">CUSTOMER SERVICE</div>
                    <div class="topspotSubheading">We're here to help!</div>
                </a>
                <div class="topspotPrimary">
                    <a href="https://cardkingdom.freshdesk.com/support/tickets/new" data-cktag="Customer Service - Open Ticket">Open new support ticket</a>
                    <a href="https://cardkingdom.freshdesk.com/support/tickets" data-cktag="Customer Service - Check Ticket">Check existing ticket status</a>
                </div>
            </div>
            <div class="footerTopspotC">
                <a href="https://app.e2ma.net/app2/audience/signup/1823535/1779405/" target="_blank" data-cktag="Email SignUp">
                    <div class="topspotImage"><span class="glyphicon glyphicon-envelope"></span></div>
                    <div class="topspotHeading">SIGN-UP FOR EMAIL</div>
                    <div class="topspotSubheading">News, articles, events &amp; coupons</div>
                </a>
                <div class="topspotPrimary">
                    <a href="https://app.e2ma.net/app2/audience/signup/1823535/1779405/" target="_blank" data-cktag="Email SignUp">Sign up Now!</a>
                </div>
            </div>
            <div class="footerTopspotA storeInfo">
                <div class="topspotImage"><span class=""></span></div>
                <div class="topspotHeading">RETAIL LOCATIONS</div>
                <div class="topspotPrimary">
                    <ul class="footerLocationDetails">
                        <li class="itemTitle">Mox Boarding House</li>
                        <li class="city">Seattle</li>
                        <li><a href="https://www.moxboardinghouse.com/locations/" target="_blank" data-cktag="Mox Seattle - Store Info">Store Information</a></li>
                        <li><a href="https://www.moxboardinghouse.com/seattle-events" target="_blank" data-cktag="Mox Seattle - Event Schedules">Event Schedules</a></li>
                    </ul>
                    <ul class="footerLocationDetails col2">
                        <li class="itemTitle">Mox Boarding House</li>
                        <li class="city">Bellevue</li>
                        <li><a href="https://www.moxboardinghouse.com/locations/" target="_blank" data-cktag="Mox Bellevue - Store Info">Store Information</a></li>
                        <li class=""><a href="https://www.moxboardinghouse.com/bellevue-events" target="_blank" data-cktag="Mox Bellevue - Event Schedules">Event Schedules</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="f2 footerCallout container"><h2>FASTEST SHIPPING IN THE MULTIVERSE</h2>
            <a class="twitterIcon" href="https://twitter.com/Card_Kingdom" target="_blank" data-cktag="Twitter"></a>
            <a class="facebookIcon" href="https://www.facebook.com/pages/Seattle-WA/Card-Kingdom/329274456626?ref=search&amp;sid=1347837588.117940062..1" target="_blank" data-cktag="Facebook"></a>
        </div>
        <CmsFooterMenuContainer data-set="footerMenu"/>
        <div class="f4 footerFooter container">
            <span class="authBadge"></span>
            <span class="copyright">© 1999-{{ date('Y') }} Card Kingdom, Inc.</span>
        </div>
    </div>
</template>

<script>
  import CmsFooterMenuContainer from '../containers/CmsContainer.vue';

  export default {
    components: {
      CmsFooterMenuContainer,
    },
  };
</script>

